import initHelp from '~/help/help';

document.addEventListener('DOMContentLoaded', initHelp);
